<template>
  <button :type="type" class="kd-button-medium">
    <div class="kd-button-medium__text">{{ text }}</div>
  </button>
</template>

<script>
export default {
  props: {
    text: String, 
    type: {
      type: String,
      default: 'button',
    },
  },
};
</script>

<style lang="scss">
.kd-button-medium {
  // default button-style overwrites
  overflow: visible;
  text-transform: none;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;
  /* Normalize `line-height`. Cannot be changed from `normal` in Firefox 4+. */
  line-height: normal;
  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  /* Corrects inability to style clickable `input` types in iOS */
  -webkit-appearance: none;

  // custom styles
  width: 100%;
  height: 36px;
  background-color: #EDEDED;
  color: #333333;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  &:hover {
    opacity: 0.8;
  }

  @media all and (max-height: 680px) {
    height: 30px;
  }
}

.kd-button-medium__text {
  position: relative;
  top: 1px;
  font-size: 13px;
  font-weight: 600;
}
</style>
